// extracted by mini-css-extract-plugin
module.exports = {"container":"RandstadAppsDetails_container__1N2lO","appsContainer":"RandstadAppsDetails_appsContainer__4WcpJ"};